module.exports = __webpack_public_path__ + "fc8ed04900a7b97b757d6d9f00fe8e42.MP3";